import { Paper, Typography } from '@mui/material';
import React from 'react';
import values from '../../values/values';
import colors from '../../values/colors';

function BasicCard(props) {
    return (
        <Paper style={{
                display: 'flex', 
                flexWrap: 'wrap', 
                flexDirection: 'column',
                padding: values.padding[0],
                backgroundColor: props.transparent ? 'transparent' : colors.getTheme().palette.background.paper,
                ...props.style,
                width: '100%',
                maxWidth: '100%',
                minWidth: 0,
                boxSizing: 'border-box',
                overflowX: props.style?.overflowX || props.style?.overflow || 'auto',
            }}>
            {props.title && (
                <Typography style={{ flex: 1, display: 'flex', alignItems: 'center' }} color={props.color}>
                    {props.title}
                </Typography>
            )}
            {props.children && 
                <div style={{flex: 1, display: 'flex', flexWrap: 'wrap', width: '100%', maxWidth: '100%', minWidth: 0}}>
                    {props.children}
                </div>
            }
        </Paper>
    );
}

export default BasicCard;